<bricks-alert-container position="bottom-center">
  @for (notification of notifications() | keyvalue; track notification.key) {
    <bricks-alert
      [title]="notification.value.title"
      [type]="notification.value.type"
      [isClosable]="true"
      (closeAlert)="dismiss(notification.key)">
      <div [innerHTML]="notification.value.description"></div>
    </bricks-alert>
  }
</bricks-alert-container>
